export const config = {
  minVersion: '3.0.0',
  url: 'wss://lh.testsmarter.net:8443',
}
